import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CssBaseline from '@material-ui/core/CssBaseline';
import Paper from '@material-ui/core/Paper';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import Typography from '@material-ui/core/Typography';
import Grid from '@material-ui/core/Grid';
import PropTypes from 'prop-types';
import { withRouter } from 'react-router-dom'
import { AddUser, GetUser, EditUser } from '../../fetchs';

const useStyles = theme => ({
  appBar: {
    position: 'relative',
  },
  layout: {
    width: 'auto',
    marginLeft: theme.spacing(2),
    marginRight: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(2) * 2)]: {
      width: 600,
      marginLeft: 'auto',
      marginRight: 'auto',
    },
  },
  paper: {
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
    padding: theme.spacing(2),
    [theme.breakpoints.up(600 + theme.spacing(3) * 2)]: {
      marginTop: theme.spacing(6),
      marginBottom: theme.spacing(6),
      padding: theme.spacing(3),
    },
  },
  stepper: {
    padding: theme.spacing(3, 0, 5),
  },
  buttons: {
    display: 'flex',
    justifyContent: 'flex-end',
  },
  button: {
    marginTop: theme.spacing(3),
    marginLeft: theme.spacing(1),
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  // textField: {
  //   marginLeft: theme.spacing(1),
  //   marginRight: theme.spacing(1),
  //   width: 200,
  // },
});

class User extends Component {
  constructor(props) {
    super(props);

    this.state = {
      firstName: '',
      lastName: '',
      username: '',
      password: '',
      retypePassword: '',
      phoneNumber: '',
      email: '',
      //isActive: true,
      loading: false,
      saving: false
    }
  }

  componentDidMount() {
    if (this.props.match.params.userId) {
      GetUser(this.props.match.params.userId)
        .then(response => {
          return response.json();
        }).then(responseJson => {
          this.setState({
            firstName: responseJson.firstName,
            lastName: responseJson.lastName,
            username: responseJson.username,
            phoneNumber: responseJson.phoneNumber,
            email: responseJson.email,
            //isActive: responseJson.isActive
          });
        }).catch(error => {
          console.error(error);
        })
    }
  }

  handleSave = () => {
    if (this.state.password !== this.state.retypePassword) {
      alert("کلمه عبور به درستی وارد نشده است");
      return;
    }
    if (this.props.match.params.userId) {
      EditUser(this.props.match.params.userId, {
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        username: this.state.username,
        password: this.state.password,
        phoneNumber: this.state.phoneNumber,
        email: this.state.email,
        //isActive: this.state.isActive
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/users');
        }
        return response.json();
      }).then(responseJson => {
        if (responseJson === "Username length must be at least 4 characters") {
          alert("نام کاربری نمی تواند خالی باشد");
        } else if (responseJson === "LastName can not be empty") {
          alert("نام خانوادگی نمی تواند خالی باشد");
        }else if (responseJson === "FirstName can not be empty") {
          alert("نام نمی تواند خالی باشد");
        }else if (responseJson === "Password length must be at least 5 characters") {
          alert("حداقل تعداد کاراکتر مجاز برای کلمه عبور 5 می باشد");
        }else if (responseJson === "Phone number length must be 11 characters") {
          alert("شماره همراه باید11 کاراکتر باشد");
        }else if (responseJson === "Email is not in a correct format") {
          alert("فرمت ایمیل به درستی وارد نشده است");
        }
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    } else {
      AddUser({
        firstName: this.state.firstName,
        lastName: this.state.lastName,
        username: this.state.username,
        password: this.state.password,
        phoneNumber: this.state.phoneNumber,
        email: this.state.email,
      }).then(response => {
        if (response.status === 400) {
          console.log(response);
        } else if (response.status === 200) {
          this.props.history.push('/main/users');
        }
        return response.json();
      }).then(responseJson => {
        if (responseJson === "Username length must be at least 4 characters") {
          alert("نام کاربری نمی تواند خالی باشد");
        } else if (responseJson === "LastName can not be empty") {
          alert("نام خانوادگی نمی تواند خالی باشد");
        }else if (responseJson === "FirstName can not be empty") {
          alert("نام نمی تواند خالی باشد");
        }else if (responseJson === "Password length must be at least 5 characters") {
          alert("حداقل تعداد کاراکتر مجاز برای کلمه عبور 5 می باشد");
        }else if (responseJson === "Phone number length must be 11 characters") {
          alert("شماره همراه باید11 کاراکتر باشد");
        }else if (responseJson === "Email is not in a correct format") {
          alert("فرمت ایمیل به درستی وارد نشده است");
        }
        console.log(responseJson.message);
      }).catch(error => {
        console.error(error);
      });
    }
  };

  handleCheckChange = name => event => {
    this.setState({ [name]: event.target.checked });
  };

  handleChange = name => event => {
    this.setState({ [name]: event.target.value });
  }

  render() {
    const { classes } = this.props;
    return (
      <React.Fragment>
        <CssBaseline />
        <main className={classes.layout}>
          <Paper className={classes.paper}>
            <Typography component="h1" variant="h4" align="center">
              افزودن کاربر جدید
            </Typography>
            <React.Fragment>
              <form className={classes.container} noValidate autoComplete="off">
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      id="standard-username"
                      label="نام کاربری"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.username}
                      onChange={this.handleChange('username')}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="standard-first-name"
                      label="نام"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.firstName}
                      onChange={this.handleChange('firstName')}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="standard-last-name"
                      label="نام خانوادگی"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.lastName}
                      onChange={this.handleChange('lastName')}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="standard-phone-number"
                      label="شماره موبایل"
                      required
                      fullWidth
                      className={classes.textField}
                      value={this.state.phoneNumber}
                      onChange={this.handleChange('phoneNumber')}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="standard-email"
                      label="رایانامه"
                      fullWidth
                      className={classes.textField}
                      value={this.state.email}
                      onChange={this.handleChange('email')}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="standard-password"
                      label="رمز عبور"
                      type="password"
                      fullWidth
                      autoComplete="current-password"
                      className={classes.textField}
                      value={this.state.password}
                      onChange={this.handleChange('password')}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    <TextField
                      id="standard-retype-password"
                      label="تکرار رمز عبور"
                      type="password"
                      fullWidth
                      autoComplete="current-password"
                      className={classes.textField}
                      value={this.state.retypePassword}
                      onChange={this.handleChange('retypePassword')}
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12}>
                    <Button
                      variant="contained"
                      color="primary"
                      fullWidth
                      disabled={this.state.loading}
                      onClick={this.handleSave}>ذخیره</Button>
                  </Grid>
                </Grid>
              </form>
            </React.Fragment>
          </Paper>
        </main>
      </React.Fragment>
    )
  };
}

User.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withRouter(withStyles(useStyles)(User));
